import { toast } from "react-toastify";
import defaultErrorHandler from "actions/global/default-error-handler";
import {
  requestPackageGetList,
  requestPackageAdd,
  requestPackageAddImage,
  requestPackageGetImage,
  requestPackageGetUnitsOfMeasurement,
  requestPackageAssign
} from "actions/package/requests";

import {
  PACKAGE_LOADING,
  PACKAGE_ERROR,
  PACKAGE_GET_LIST,
  PACKAGE_RESET_LIST,
  PACKAGE_ADD,
  PACKAGE_ADD_IMAGE,
  PACKAGE_GET_IMAGE,
  PACKAGE_GET_UNITS_OF_MEASUREMENT,
  PACKAGE_ASSIGN_TO_USERS_LIST
} from "actions/package/constants";

export const setLoading = (status) => ({
  type: PACKAGE_LOADING,
  payload: status
});

export const packageGetList = () => dispatch => {
  dispatch(setLoading(true));
  requestPackageGetList()
    .then(response => {
      dispatch({
        type: PACKAGE_GET_LIST,
        payload: response.data
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, PACKAGE_ERROR));
    });
};

export const actionResetList = () => dispatch => {
  dispatch({
    type: PACKAGE_RESET_LIST
  });
};

export const packageAdd = (data) => dispatch => {
  dispatch(setLoading(true));
  requestPackageAdd(data)
    .then(response => {
      dispatch({
        type: PACKAGE_ADD,
        payload: response.data.content
      });
      toast("Package updated successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, PACKAGE_ERROR));
    });
};

export const packageAddImage = (id, img, callback) => dispatch => {
  dispatch(setLoading(true));
  requestPackageAddImage(id, img)
    .then(response => {
      dispatch({
        type: PACKAGE_ADD_IMAGE,
        payload: response.data
      });
      toast("Image added successfully", {
        type: toast.TYPE.SUCCESS,
      });
      callback();
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, PACKAGE_ERROR));
    });
};

export const packageGetImage = (id) => dispatch => {
  dispatch(setLoading(true));
  requestPackageGetImage(id)
    .then(response => response.data.arrayBuffer())
    .then(buffer => {
      const blob = new Blob([buffer]);
      const url = URL.createObjectURL(blob);
      dispatch({
        type: PACKAGE_GET_IMAGE,
        payload: url
      });
    })
    .catch(() => {
      dispatch(setLoading(false));
    });
};

export const packageGetUnitsOfMeasurement = () => dispatch => {
  dispatch(setLoading(true));
  requestPackageGetUnitsOfMeasurement()
    .then(response => {
      dispatch({
        type: PACKAGE_GET_UNITS_OF_MEASUREMENT,
        payload: response.data
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, PACKAGE_ERROR));
    });
};

export const packageAssign = (packageId, usersIdArr) => dispatch => {
  dispatch(setLoading(true));
  requestPackageAssign(packageId, usersIdArr)
    .then(response => {
      dispatch({
        type: PACKAGE_ASSIGN_TO_USERS_LIST,
        payload: response.data
      });
      toast("Package assigned successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, PACKAGE_ERROR, true));
    });
};



// WEBPACK FOOTER //
// ./src/actions/package/actions.js